import { motion } from "motion/react";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Choo Xin Yue",
    text: "I am Xin Yue under SCS Education, and my agent is Sister Su Xin. She is really patient, very nice, and speaks so gently. There was a period when I reached out to her, but then I stopped contacting her because I was preparing for my exam. After my exam, I was surprised tht she was still willing to reply to me and continue assisting me. She handled every detail very well and helped me with great effort. She is truly a wonderful agent, and I highly recommend sister Su Xin! This is my most sincere review",
    rating: 5,
    avatar: "XY",
    avatarColor: "#7C3AED",
  },
  {
    name: "Wen Shann",
    text: "I had such a great experience with SCS Education! Elmo was incredibly helpful and explained everything clearly - from the different university options to their unique strengths. Thanks to Elmo's detailed guidance, I was able to fully understand what each school offers and chooes the one that match my goals. The universities recommended to me were all excellent and truly suited my needs. I even receive multiple offers and scholarships! If you're unsure about where to start, I highly recommend reaching out to SCS Education. Thank you so much, Elmo!",
    rating: 5,
    avatar: "WS",
    avatarColor: "#F97316",
  },
  {
    name: "Yap Ying Yi",
    text: "I love the way that my consultant Genesis consulting and guiding me through the right pathway. She helped me with my Singapore and Australia study and I am successfully in AUS University of Newcastle now. A big thanks to Genesis and SCS Education!",
    rating: 5,
    avatar: "YY",
    avatarColor: "#06B6D4",
  },
  {
    name: "Ng Si Yong",
    text: "I would definitely recommend SCS Education Consultancy services if you are interested in studying in the UK. They will assist you for the whole application process. Including how to fill up the form, Visa application, transport and hostel arrangement as well. Kah Hau is very friendly and assist us well for the whole application.",
    rating: 5,
    avatar: "SY",
    avatarColor: "#EC4899",
  },
  {
    name: "victchen1706",
    text: "I would like to express my sincere graditute to Mr Matthew for his invaluable guidance and support in helping my son with his further studies. From the moment we reached out to him, it was clear that he possesses extensive knowledge and expertise in educational consulting. Very grateful for Mr Matthew's guidance and would highly recommend his services to anyone looking for expert advice on further education.",
    rating: 5,
    avatar: "VC",
    avatarColor: "#84CC16",
  },
  {
    name: "Yeoh Yeoh",
    text: "I was looking for college counseling and met Su Xin, the counselor at this organization. She listened very attentively and patiently to my appeals. Even if I asked her matters outside the scope of her work, such as the difficulties I encountered when I first entered the society, she would try her best to help me.",
    rating: 5,
    avatar: "YY",
    avatarColor: "#7C3AED",
  },
];

function TestimonialCard({ t, delay }: { t: typeof testimonials[0]; delay: number }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="bg-white rounded-3xl p-7 border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-slate-900/5 transition-all duration-500 hover:-translate-y-1 flex flex-col h-full"
    >
      {/* Stars */}
      <div className="flex gap-1 mb-4">
        {Array.from({ length: t.rating }).map((_, i) => (
          <Star key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
        ))}
      </div>

      {/* Quote */}
      <div className="relative mb-5 flex-1">
        <Quote className="w-7 h-7 text-slate-100 absolute -top-2 -left-1" />
        <p
          className="text-[14px] text-slate-600 leading-relaxed relative z-10 pl-2"
          style={{ fontFamily: "Inter, sans-serif", fontWeight: 400 }}
        >
          "{t.text}"
        </p>
      </div>

      {/* Author */}
      <div className="flex items-center gap-3 pt-4 border-t border-slate-50">
        <div
          className="w-10 h-10 rounded-2xl flex items-center justify-center text-white text-[12px]"
          style={{ backgroundColor: t.avatarColor, fontFamily: "Inter, sans-serif", fontWeight: 700 }}
        >
          {t.avatar}
        </div>
        <div>
          <p
            className="text-[13px] text-slate-900"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 600 }}
          >
            {t.name}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

export function TestimonialsSection() {
  return (
    <section className="py-24 lg:py-32 bg-[#FAFAFA] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-50 border border-amber-100 mb-6">
            <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
            <span
              className="text-[12px] text-amber-700 uppercase tracking-widest"
              style={{ fontFamily: "Inter, sans-serif", fontWeight: 700 }}
            >
              Student Stories
            </span>
          </div>
          <h2
            className="text-[40px] lg:text-[52px] text-slate-900 tracking-tight mb-4"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 800, lineHeight: 1.1 }}
          >
            Real students.{" "}
            <span
              style={{
                background: "linear-gradient(135deg, #F59E0B, #F97316)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Real results.
            </span>
          </h2>
          <p
            className="text-[16px] text-slate-500 max-w-xl mx-auto"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 400 }}
          >
            Over 10,000 students have launched their futures with SCS Education. Here are some of
            their stories.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} t={t} delay={i * 0.08} />
          ))}
        </div>
      </div>
    </section>
  );
}
